let validationClass = function (vm) {
  let validationClass = false
  if (vm.isLoading) {
    validationClass = 'info'
  } else if (vm.isDirty) {
    validationClass = vm.isValid ? 'success' : 'danger'
  }
  if (validationClass) {
    return 'form-validation-' + validationClass
  } else {
    return false
  }
}
let validationMessage = function (vm) {
  let msgs = {
    loadingMessage: 'Loading...',
    invalidMessage: 'Invalid value!',
    customMessage: false,
    ...vm.options
  }
  if (vm.invalidMessage) {
    msgs.invalidMessage = vm.invalidMessage
  }
  let msg = false
  if (vm.isLoading) {
    msg = msgs.loadingMessage
  } else if (vm.customError && vm.isDirty) {
    msg = vm.customError
  } else if (vm.isDirty && !vm.isValid) {
    msg = msgs.invalidMessage
  }
  return msg
}
let validationIcon = function (vm) {
  let iconClass = false
  if (vm.isValid) {
    iconClass = 'success fa-check'
  } else {
    iconClass = 'danger fa-times'
  }
  if (vm.isLoading) {
    iconClass = 'info fa-circle-notch fa-spin'
  }
  if (iconClass && vm.isDirty) {
    return 'fa form-control-feedback text-' + iconClass
  } else {
    return false
  }
}

let randomLabel = function (label, classPrefix = 'badge') {
  let num = label.charCodeAt(0)
  let template = {
    '-warning': num % 5 === 0,
    '-primary': num % 5 === 1,
    '-danger': num % 5 === 2,
    '-default': num % 5 === 3,
    '-info': num % 5 === 4
  }
  let result = {}
  for (let key in template) {
    result[classPrefix + key] = template[key]
  }
  return result
}

let iconMap = {
  AccountNote: {
    'Account Deactivation Request': 'fa-ban',
    'Request Clean': 'fa-shower',
    'New drivers license uploaded': 'fa-address-card',
    'Proof of enrolment updated:': 'fa-university',
    'Yearly Membership Fee Declined': 'fa-exclamation-triangle',
    'Low Fuel Report': 'fa-tachometer-alt',
    'Damage Report': 'fa-wrench'
  },
  AdminRequest: {
    'Request Clean': 'fa-shower',
    'Reservation Charge': 'fa-dollar-sign',
    'Car Change Request': 'fa-exchange-alt',
    'Damage Report': 'fa-wrench',
    'Low Fuel Report': 'fa-tachometer-alt',
    'Car Space Taken': 'fa-times-circle',
    'High KM': 'fa-road'
  }
}

export {
  validationClass,
  validationMessage,
  validationIcon,
  randomLabel,
  iconMap
}



// WEBPACK FOOTER //
// ./src/util/helpers.js